import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const deleteTemplate = createAsyncThunk(
  "templateDetail/deleteTemplate",
  async (data, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { id } = state.templateDetail.template;

      const { data } = await axiosInstance.delete(`${api.baseURL}form/${id}`);

      return { success: true, deleted: data.id };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
